export const CHECKOUT_CONSTANTS = {
  ORDER_SUMMARY: "Order Summary",
  SHIPPING_DETAILS: "Shipping Details",
  SELECT_PAYMENT_METHOD: "Select Payment Method",
  CARD_OPTIONS: "Credit/Debit Card",
  UPI: "UPI",
  UPI_PLACEHOLDER: "Enter your UPI ID",
  SUBTOTAL: "Subtotal",
  ORDER_TOTAL: "Order Total",
  USE_POINTS: "Use Points",
  REFERRAL_CODE: "Referral Code",
  REFERRAL: "R",
  COUPON_CODE: "Coupon Code",
  COUPON: "C",
  COUPON_DISCOUNT_TEXT: "Coupon Discount Amount",
  REFERRAL_DISCOUNT_TEXT: "Referral Discount Amount",
  SHIPPING_FIELDS: [
    {
      id: "first_name",
      label: "First Name*",
      placeholder: "Enter first name",
    },
    {
      id: "last_name",
      label: "Last Name*",
      placeholder: "Enter last name",
    },
    {
      id: "mobile_number",
      label: "Mobile No*",
      placeholder: "Enter mobile number",
    },
    {
      id: "email",
      label: "Email*",
      placeholder: "Enter email",
      type: "email",
    },
    {
      id: "address",
      label: "Street Address*",
      placeholder: "Enter street address",
    },
    { id: "state_name", label: "State*", placeholder: "Enter state" },
    { id: "city_name", label: "City*", placeholder: "Enter city" },
    { id: "pincode", label: "Pin Code*", placeholder: "Enter pin code" },
  ],
};
